<template>
  <div class="flex-y-center flex-col justify-center space-y-2">
    <h3
      :class="[colored ? 'text-green-700' : 'text-dark']"
      class="text-[48px] leading-[48px] xl:text-[64px] xl:leading-[64px] font-bold !direction-ltr"
    >
      {{ value }}
    </h3>
    <p class="text-base xl:text-lg text-gray">{{ title }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  value: string | number;
  colored?: boolean;
}
withDefaults(defineProps<Props>(), {
  colored: false,
});
</script>

<style scoped></style>
